import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, TrendingUp, Shield, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <TrendingUp className="h-6 w-6 text-primary-400" />
              <span className="text-xl font-bold text-white">Algodhan</span>
            </div>
            <p className="text-sm text-gray-400 max-w-sm">
              Your intelligent investment companion. We help you build a personalized portfolio 
              based on your risk profile and financial goals.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/register" className="hover:text-white transition-colors">Get Started</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Login</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">Contact Us</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary-400 flex-shrink-0" />
                <a href="mailto:roboadvisorresearch@gmail.com" className="hover:text-white transition-colors">
                  roboadvisorresearch@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Shield className="h-4 w-4 text-primary-400 flex-shrink-0" />
                <span>Secure & Encrypted</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary-400 flex-shrink-0" />
                <span>Support Available</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Algodhan. All rights reserved.
          </p>
          <p className="text-xs text-gray-500">
            Built for smart investing decisions.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
